
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]/lineup/timetable",
      function () {
        return require("private-next-pages/events/[slug]/lineup/timetable/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[slug]/lineup/timetable"])
      });
    }
  